import React from 'react';
import { Check, Clock, Circle } from 'lucide-react';
import { formatDateTime, timelineLabel } from '../lib/brand';

export default function Timeline({ steps, dataTestId = 'case-timeline' }) {
  return (
    <ol className="relative border-s border-slate-200 ms-3 space-y-6" data-testid={dataTestId}>
      {(steps || []).map((s, idx) => {
        const isDone = s.status === 'done';
        const isActive = s.status === 'active';
        const Icon = isDone ? Check : isActive ? Clock : Circle;
        const bg = isDone
          ? 'bg-[hsl(var(--success))] text-white border-[hsl(var(--success))]'
          : isActive
          ? 'bg-[hsl(var(--accent))] text-white border-[hsl(var(--accent))]'
          : 'bg-white text-slate-400 border-slate-200';
        return (
          <li key={s.key} data-testid={`${dataTestId}-step-${idx}`} className="ms-6">
            <span className={`absolute -start-3 mt-1 h-6 w-6 rounded-full border flex items-center justify-center ${bg}`}>
              <Icon className="h-3.5 w-3.5" />
            </span>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
              <div className="font-heading font-semibold text-slate-900">{timelineLabel(s)}</div>
              {s.timestamp && (
                <div className="text-xs text-slate-500">{formatDateTime(s.timestamp)}</div>
              )}
            </div>
            {s.note && <div className="text-sm text-slate-600 mt-1">{s.note}</div>}
            {!isDone && !isActive && <div className="text-xs text-slate-400 mt-0.5">Ausstehend</div>}
          </li>
        );
      })}
    </ol>
  );
}
